import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { BasicDataSubService } from '../../../../shared/basic-data-management/basic-data-subservice.class';
import { CachedDataSurveyService } from '../../../../technical-modules/tasks/services/cached-data-survey.service';

import { TypeQualificationTLR } from "../entities/type-qualification-tlr.entity";

@Injectable({ providedIn: 'root' })
export class TypeQualificationService {
	private path: string;
	private typesQualificationsTLRSubService!: BasicDataSubService<TypeQualificationTLR>;

	constructor( //
		@Inject(HttpClient) httpClient: HttpClient, //
		@Inject(CachedDataSurveyService) cachedDataSurveyService: CachedDataSurveyService, //
		@Optional() @SkipSelf() previousInstance?: TypeQualificationService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
		this.path = (window as any).baseApiPath;
		let typesChanged$ = cachedDataSurveyService.getChangeNotification("TypeQualification");
		this.typesQualificationsTLRSubService = new BasicDataSubService<TypeQualificationTLR>(httpClient, this.path + 'types-qualifications?format=TLR', typesChanged$);
	}

	// Methode permettant le chargement de toutes les entites
	public getList = () => this.typesQualificationsTLRSubService.getList();

	// Methodes permettant le chargement de tous les entities, selon differentes classifications et indexs
	// (NB: on procede a toutes les classifications en une fois, ce qui permet de n'iterer qu'une seule fois pour tous les resultats)
	public getMapById = () => this.typesQualificationsTLRSubService.getMapById();
	public getById = (id: number) => this.typesQualificationsTLRSubService.getKnownById(id, "UserTLR");
}